<app-dialog [dialogWithInput]="dialog">
    <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverDropZone($event)" [uploader]="fileUploader" class="drop-zone">
        Déposez le fichier ici
    </div>

    <label>
        <input type="file" ng2FileSelect [uploader]="fileUploader" />
        Ajouter un fichier
    </label>
    <div *ngIf="fileUploader.queue.length > 0">
        <h5>Fichiers joints</h5>
        <p>
            <span *ngFor="let queueElement of fileUploader.queue">{{queueElement.file?.name}} <br/></span>
        </p>
    </div>

    <ng-container dialog-actions>
        <app-button label="Joindre" (clickEvent)="validate()" iconName="paperclip" fill="solid"></app-button>
    </ng-container>
</app-dialog>
